import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const Footer = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="border-t bg-background">
      <div className="container py-6 md:py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h3 className="text-base font-semibold mb-3">{t('common.about')}</h3>
            <p className="text-sm text-muted-foreground mb-3">
              {language === 'en' 
                ? 'TruStay helps tenants share experiences and find better rental opportunities.' 
                : 'TruStay 幫助租客分享經驗並找到更好的租房機會。'}
            </p>
            <div className="flex items-center space-x-2 text-xs text-muted-foreground">
              <Mail className="h-3 w-3" />
              <span>customer.service@trustay.app</span>
            </div>
          </div>
          
          <div>
            <h3 className="text-base font-semibold mb-3">{t('common.links')}</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('/')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t('common.home')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/reviews')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t('common.reviews')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/submit')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t('common.submit')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/guides')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t('common.guides')}
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-base font-semibold mb-3">{language === 'en' ? 'Legal' : '法律資訊'}</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('/terms')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {language === 'en' ? 'Terms of Service' : '服務條款'}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/privacy')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {language === 'en' ? 'Privacy Policy' : '隱私政策'}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/faq')}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-6 pt-6 text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} TruStay. {language === 'en' ? 'All rights reserved.' : '保留所有權利。'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
